import React from "react";
import { Mail, UsersRound, CalendarClock, Languages } from "lucide-react";
import PageHeader from "@/components/admin/PageHeader";
import EnableFeatureCard from "@/components/admin/EnableFeatureCard";
import HowThisWorks from "@/components/admin/HowThisWorks";

export function HelpdeskEmail() {
    return (
        <div className="p-10 max-w-5xl">
            <PageHeader eyebrow="Help desk · Beta" title="Email" description="Turn incoming guest emails into tickets Priya can triage and respond to." testid="page-helpdesk-email" />
            <EnableFeatureCard
                title="Email-to-ticket"
                description="Connect a support inbox and let Priya auto-categorise emails, draft replies and create tickets."
                icon={Mail}
                actionLabel="Enable"
                testid="helpdesk-email"
                feature="helpdesk_email"
            />
            <HowThisWorks
                steps={[
                    "Enable Help desk and connect a support inbox (Gmail, Outlook, IMAP).",
                    "Incoming emails are auto-converted into tickets and categorised (booking, billing, login, etc.).",
                    "Track, respond and resolve tickets directly from the Help desk dashboard.",
                ]}
            />
        </div>
    );
}

export function HelpdeskAssignment() {
    return (
        <div className="p-10 max-w-5xl">
            <PageHeader eyebrow="Help desk · Beta" title="Ticket assignment" description="Route and assign tickets automatically to the right agent or team." testid="page-helpdesk-assignment" />
            <EnableFeatureCard
                title="Automatic ticket routing"
                description="Set assignment rules — round-robin, by priority, by tag, or by team — so every ticket lands with the right person."
                icon={UsersRound}
                actionLabel="Enable"
                testid="helpdesk-assignment"
                feature="helpdesk_assignment"
            />
            <HowThisWorks
                steps={[
                    "Enable Help desk to start managing agent schedules and assignments.",
                    "Define assignment rules: round-robin, priority-based, tag-based, or team-based.",
                    "New tickets are automatically routed to the right agent in real time.",
                ]}
            />
        </div>
    );
}

export function HelpdeskScheduling() {
    return (
        <div className="p-10 max-w-5xl">
            <PageHeader eyebrow="Help desk · Beta" title="Scheduling" description="Manage agent schedules and availability so coverage is handled automatically." testid="page-helpdesk-scheduling" />
            <EnableFeatureCard
                title="Manage agent schedules and availability"
                description="Define shifts, working hours and time zones so the right agent is always on duty."
                icon={CalendarClock}
                actionLabel="Enable"
                testid="helpdesk-scheduling"
                feature="helpdesk_scheduling"
            />
            <HowThisWorks
                steps={[
                    "Enable Help desk to start managing agent schedules.",
                    "Define shifts with working days, hours and time zones for your team.",
                    "Assign agents to shifts so availability is handled automatically.",
                ]}
            />
        </div>
    );
}

export function HelpdeskTranslation() {
    return (
        <div className="p-10 max-w-5xl">
            <PageHeader eyebrow="Help desk · Beta" title="Translation" description="AI-powered translation so your agents support guests in any language." testid="page-helpdesk-translation" />
            <EnableFeatureCard
                title="AI translation for tickets"
                description="Priya auto-detects the language of incoming tickets and translates both ways so your agents can respond naturally."
                icon={Languages}
                actionLabel="Enable"
                testid="helpdesk-translation"
                feature="helpdesk_translation"
            />
            <HowThisWorks
                steps={[
                    "Enable Help desk and turn on Translation.",
                    "Incoming tickets are auto-detected for language and translated to your team's working language.",
                    "Replies from agents are translated back to the guest's language automatically.",
                ]}
            />
        </div>
    );
}
